/**
 * @generated SignedSource<<81df150fcaecbc58ecada2ee21cc48ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SchoolItem_school$data = {
  readonly location: string;
  readonly title: string;
  readonly " $fragmentType": "SchoolItem_school";
};
export type SchoolItem_school$key = {
  readonly " $data"?: SchoolItem_school$data;
  readonly " $fragmentSpreads": FragmentRefs<"SchoolItem_school">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SchoolItem_school",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "location",
      "storageKey": null
    }
  ],
  "type": "School",
  "abstractKey": null
};

(node as any).hash = "18ba0ca28d63d0d0d9b86fee9f193607";

export default node;
